"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = exports.getContentLanguageHeader = exports.getAcceptLanguageHeader = void 0;
function getAcceptLanguageHeader() {
    return `accept-language`;
}
exports.getAcceptLanguageHeader = getAcceptLanguageHeader;
function getContentLanguageHeader() {
    return `content-language`;
}
exports.getContentLanguageHeader = getContentLanguageHeader;
function Language(language) {
    return Array.isArray(language) ? language.join(",") : language;
}
exports.Language = Language;
